export default {
  methods: {
    definirIcono(valor) {
      return valor ? 'check' : 'times'
    },
    definirColor(valor) {
      return valor ? 'is-success' : 'is-danger'
    }
  }
}
